import { MouseEventHandler, ReactNode } from 'react';
import {
  ButtonProps,
  ButtonPropsSizeOverrides,
  ButtonPropsVariantOverrides,
} from '@mui/material';
import { OverridableStringUnion } from '@mui/types';
import Button from '@mui/material/Button';
import TooltipComponent from '../TooltipComponent';

interface ButtonComponentProps extends ButtonProps {
  circular?: boolean;
  iconOnly?: boolean;
  fullWidth?: boolean;
  children?: ReactNode;
  onClick?: MouseEventHandler<any> | undefined;
  tooltipMessage?: string;
  variant?:
    | OverridableStringUnion<
        'text' | 'outlined' | 'contained',
        ButtonPropsVariantOverrides
      >
    | undefined;
  size?:
    | OverridableStringUnion<
        'small' | 'medium' | 'large',
        ButtonPropsSizeOverrides
      >
    | undefined;
}

const ButtonComponent = ({
  children,
  variant,
  size,
  onClick,
  color,
  tooltipMessage,
  ...rest
}: ButtonComponentProps) => {
  return (
    <TooltipComponent title={tooltipMessage}>
      <Button
        {...rest}
        sx={{
          textTransform: 'none',
          '&.Mui-disabled': {
            opacity: 0.5,
            backgroundColor: (theme) => theme.palette.grey[800],
            color: (theme) => theme.palette.text.primary,
          },
          '&.MuiLoadingButton-loading': {
            color: 'inherit',
            backgroundColor:
              variant === 'contained' ? 'primary.main' : 'inherit',
            borderColor: variant === 'outlined' ? 'primary.main' : 'inherit',
          },
          '& .MuiLoadingButton-loadingIndicator': {
            color: 'inherit',
          },
          ...rest.sx,
        }}
        onClick={onClick}
        color={color}
        size={size}
        variant={variant ?? 'contained'}
      >
        {children}
      </Button>
    </TooltipComponent>
  );
};

export default ButtonComponent;
